"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("./WidgetError");
/**
 * Error for field validation.
 */
class FieldValidationError extends WidgetError_1.default {
    /**
     * @TODO: Refactor to set these with setters.
     */
    constructor(message, type, valueType = null, propertyKey = null) {
        super(message);
        this.type = type;
        this.valueType = valueType;
        this.propertyKey = propertyKey;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, FieldValidationError.prototype);
        this.name = this.getCode();
    }
    /**
     * Gets type of failed validation.
     *
     * @return {*}
     */
    getType() {
        return this.type;
    }
    /**
     * Gets value type of failed validation.
     *
     * @return {string} valueType
     */
    getValueType() {
        return this.valueType;
    }
    /**
     * Gets the failed property key.
     *
     * @return {string} valueType
     */
    getPropertyKey() {
        return this.propertyKey;
    }
    /**
     * @inheritDoc
     */
    toString() {
        return this.message + " " + this.type;
    }
}
/**
 * @inheritDoc
 */
FieldValidationError.code = "SW-FIELD-VALIDATION";
exports.default = FieldValidationError;
